export default __webpack_public_path__ + "static/media/Mask Group 26@2x.43f4eb3b.png";